<template>
<div class="chapter">
<div class="inner_page">
<p class="center2a"><a id="page_4">ALSO BY P. D. JAMES</a></p><a id="page_4">
<p class="center2"><span class="txit">Death Comes to Pemberley</span></p>
<p class="center2"><span class="txit">Talking About Detective Fiction</span></p>
<p class="center2"><span class="txit">The Lighthouse</span></p>
<p class="center2"><span class="txit">The Murder Room</span></p>
<p class="center2"><span class="txit">Death in Holy Orders</span></p>
<p class="center2"><span class="txit">Time to Be in Earnest: A Fragment of Autobiography</span></p>
<p class="center2"><span class="txit">A Certain Justice</span></p>
<p class="center2"><span class="txit">Original Sin</span></p>
<p class="center2"><span class="txit">The Children of Men</span></p>
<p class="center2"><span class="txit">Devices and Desires</span></p>
<p class="center2"><span class="txit">A Taste for Death</span></p>
<p class="center2"><span class="txit">The Skull Beneath the Skin</span></p>
<p class="center2"><span class="txit">Innocent Blood</span></p>
<p class="center2"><span class="txit">Death of an Expert Witness</span></p>
<p class="center2"><span class="txit">The Black Tower</span></p>
<p class="center2"><span class="txit">The Maul and the Pear Tree: The Ratcliffe Highway Murders, 1811</span> (with T. A. Critchley)</p>
<p class="center2"><span class="txit">Shroud for a Nightingale</span></p>
<p class="center2"><span class="txit">Unnatural Causes</span></p>
<p class="center2"><span class="txit">A Mind to Murder</span></p>
<p class="center2"><span class="txit">Cover Her Face</span></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// a_fm03.vue?408dbbca